import React from 'react';
import { ColorTool } from '@nextiva/rich-text-editor';
import { withProps } from 'recompose';
import TextEditorToolCaret from './TextEditorToolCaret/TextEditorToolCaret';

export default withProps({
  children: <TextEditorToolCaret />,
})(ColorTool);
